export const headerHeight = {
  mobile: '64px',
  desktop: '90px',
};
